/*
 * @LastEditors: shh
 * @Description: 
 * @Date: 2023-03-10 15:56:54
 * @LastEditTime: 2023-03-13 18:23:04
 * @FilePath: \dabaotest\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import router from './router';
import remSize from"./rem/rem";
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  router,
  remSize,
  render: h => h(App),
}).$mount('#app')

